export const TRANSFER_FORM_INPUTS = {
  to: 'to',
  confirmTo: 'confirmTo',
  captchaToken: '',
  memo: 'memo'
}
